export const CUSTOM_SOUND_MAX_SIZE_BYTES = 8_000_000; // 8MB

export const customSoundAllowedFileTypes = ['wav', 'mp3', 'ogg', 'm4a', 'flac'];

export const CUSTOM_SOUND_MAX_SIZE_MB = CUSTOM_SOUND_MAX_SIZE_BYTES / 1000000;
export const ALLOWED_FILE_TYPES_STRING = customSoundAllowedFileTypes.map((type) => `.${type.toUpperCase()}`).join(', ');
